import React, { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import moment from 'moment';
import { getBookingAudit } from '../../../services/requests/bookings/bookings-requests';

// Legacy ChangedData is rendered as HTML; only its "<br />" separators and the He3 work-order links are
// turned back into markup, everything else is shown as text.
const WORK_ORDER_LINK = /^<a href='(https:\/\/he3\.linde\.com\/maintenance\/work-orders\/\d*)' target='_blank'>\*<\/a>$/;
const renderChangedData = (text?: string) =>
  (text ?? '').split(/(<br \/>|<a href='https:\/\/he3\.linde\.com\/maintenance\/work-orders\/\d*' target='_blank'>\*<\/a>)/).map((part, i) => {
    if (part === '<br />') return <br key={i} />;
    const link = WORK_ORDER_LINK.exec(part);
    if (link) return <a key={i} href={link[1]} target="_blank" rel="noopener noreferrer">*</a>;
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });

// Legacy gvAuditLog (AuditRecord.GetAllAuditRecord, newest first) behind "Show/Hide Audit Information".
export const BookingAuditLog = ({ entity }: any) => {
  const bookingId = entity?.bookingId;
  const lastUpdated = entity?.lastUpdated;
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    if (!bookingId) return;
    let active = true;
    getBookingAudit(bookingId)
      .then((data) => active && setRows(data ?? []))
      .catch(() => active && setRows([]));
    return () => {
      active = false;
    };
  }, [bookingId, lastUpdated]);

  return (
    <div className="mt-3">
      <Button size="sm" variant="link" className="p-0" onClick={() => setOpen(!open)}>
        {open ? '−' : '+'} Show/Hide Audit Information
      </Button>
      {open && (
        <fieldset className="mt-2" style={{ maxHeight: 300, overflow: 'auto' }}>
          <legend style={{ fontSize: '1rem' }}>Audit Records</legend>
          <Table size="sm" bordered striped>
            <thead>
              <tr>
                <th>User Name</th>
                <th>IP Address</th>
                <th>Date Stamp</th>
                <th>Operation</th>
                <th>Audit Data</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td>{r.usernameFull}</td>
                  <td>{r.ip}</td>
                  <td>{r.timestamp ? moment(r.timestamp).format('M/D/YYYY h:mm:ss A') : ''}</td>
                  <td>{r.operation}</td>
                  <td>{renderChangedData(r.changedData)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </fieldset>
      )}
    </div>
  );
};
